// extracted by mini-css-extract-plugin
export default {"shell":"AppShell_shell__EgAHe","scroll":"AppShell_scroll__xdOw8","body":"AppShell_body__LrXbR"};